const awsConfig = {
  Auth: {
    // Amazon Cognito Region
    region: process.env.REACT_APP_REGION,

    // Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_USERPOOLID,

    // Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_USERPOOLWEBCLIENTID,
    mandatorySignIn: true,
  },
};

export default awsConfig;
